export default __webpack_public_path__ + "static/media/JourneyJoy.64609f7a1c1969e015e85d1e5dfcf8d9.webp";